import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsProductPage } from 'types/cms/single-types'
import { Product } from '@boltenergy-be/shared'

/**
 * Get the product page from the CMS
 *
 * @param {Product} product
 * @param {Language} locale
 * @returns {Promise<CmsProductPage | undefined>}
 */
const getProductPage = async (product: Product, locale: Language = Language.DUTCH): Promise<CmsProductPage | undefined> => {
  try {
    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsProductPage>>(`${process.env.CMS_API_URL}/landingspages/products/${product}?locale=${locale}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getProductPage
